<template>
  <div class="container_contact">
    <div class="content_main">
      <div class="content_card">
        <h2 class="title">联系我们</h2>
        <p class="subtitle">简易寻外文学术资源服务平台，一站式搞定外文文献检索、获取、翻译、解析、综述与科研选题、研究领域热点分析、发展趋势分析等全流程服务！</p>

        <div class="info_section">
          <div class="info_item">
            <div class="icon">📞</div>
            <div class="details">
              <h4>联系方式</h4>
              <p>客服电话：400-660-4011</p>
              <p class="sub_text">周一至周五（法定假日除外） 9:00～12:00 14:00～18:00</p>
            </div>
          </div>

          <div class="info_item">
            <div class="icon">📍</div>
            <div class="details">
              <h4>公司地址</h4>
              <p>江苏省徐州市泉山区高新技术创业中心305室</p>
            </div>
          </div>

          <div class="info_item">
            <div class="icon">📖</div>
            <div class="details">
              <h4>使用手册</h4>
              <p>
                访问我们的使用手册地址：
                <a href="https://bj.cxstar.cn/jyxom/" target="_blank">https://bj.cxstar.cn/jyxom/</a>
              </p>
            </div>
          </div>
        </div>

        <div class="qr_section">
          <div class="qr_card">
            <p>请添加客服企业微信进行咨询</p>
            <img src="../assets/img1.jpg" alt="客服企业微信" />
          </div>
          <div class="qr_card">
            <p>请扫码查看更多视频介绍内容</p>
            <img src="../assets/img2.png" alt="视频介绍内容" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContainerContact",

  data() {
    return {};
  },
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.container_contact {
  display: flex;
  justify-content: center;
  align-items: stretch;
  height: 100%;
  min-height: 0;
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px 20px;
  box-sizing: border-box;
}
.content_main {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  width: 100%;
  flex: 0 0 auto;
  margin-top: auto;
  margin-bottom: auto;
  padding: 30px;
  box-sizing: border-box;
}

.content_card {
  margin: 0 auto;
  max-width: 800px;
}

.title {
  font-size: 28px;
  color: #333;
  text-align: center;
  margin-bottom: 16px;
  font-weight: 600;
}

.subtitle {
  font-size: 15px;
  color: #666;
  text-align: center;
  line-height: 1.6;
  margin-bottom: 40px;
  padding: 0 20px;
}

.info_section {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 40px;
}

.info_item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    background: #f0f4f8;
  }

  .icon {
    font-size: 24px;
    background: #fff;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
  }

  .details {
    flex: 1;

    h4 {
      margin: 0 0 8px 0;
      font-size: 16px;
      color: #333;
    }

    p {
      margin: 0 0 4px 0;
      font-size: 14px;
      color: #555;
    }

    .sub_text {
      font-size: 13px;
      color: #888;
    }

    a {
      color: #1890ff;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.qr_section {
  display: flex;
  justify-content: center;
  gap: 40px;
  border-top: 1px solid #eee;
  padding-top: 40px;
}

.qr_card {
  text-align: center;
  flex: 1;
  max-width: 200px;

  p {
    font-size: 13px;
    color: #666;
    margin-bottom: 16px;
    min-height: 40px;
  }

  img {
    width: 100%;
    max-width: 160px;
    aspect-ratio: 1;
    height: auto;
    object-fit: contain;
    border-radius: 8px;
    border: 1px solid #eee;
    padding: 8px;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  }
}

@media (max-width: 600px) {
  .container_contact {
    padding: 12px;
  }

  .content_main {
    padding: 20px 16px;
  }

  .content_card {
    padding: 0;
  }

  .subtitle {
    padding: 0;
    margin-bottom: 24px;
  }

  .info_section {
    gap: 16px;
    margin-bottom: 24px;
  }

  .info_item {
    gap: 12px;
    padding: 14px;
  }

  .qr_section {
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding-top: 24px;
  }

  .qr_card {
    width: min(100%, 200px);
    flex: 0 0 auto;
  }

  .qr_card p {
    min-height: 0;
    margin-bottom: 12px;
  }
}
</style>
